import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { ChildItems } from './child-items';
import { Accordion, StyledListItem, StyledListItemContent, Counter, StyledListItemIcon, Divider } from './styled';
export const Item = memo(({ toggle, item, isOpen = false, parent, isFlat = false, onItemClick = () => null, checkSelection, isLatest }) => {
    const level2 = Boolean(parent);
    const hasChildren = useMemo(() => {
        return !!item.children;
    }, [item]);
    const handleItemClick = useCallback(() => {
        if (hasChildren) {
            toggle(item);
            item.clickable && onItemClick(item);
        }
        else {
            onItemClick(item);
        }
    }, [toggle, onItemClick, item, hasChildren]);
    const isSelected = useMemo(() => {
        if (hasChildren && !item.clickable) {
            return false;
        }
        if (checkSelection) {
            return checkSelection(item);
        }
        return false;
    }, [hasChildren, item, checkSelection]);
    useEffect(() => {
        if (parent && isSelected) {
            toggle(parent, true);
        }
    }, [isSelected, toggle, parent]);
    const countElement = useMemo(() => {
        if (item.count == null) {
            return null;
        }
        if (typeof item.count === 'function') {
            const Component = item.count;
            return React.createElement(Component, null);
        }
        else if (typeof item.count === 'object') {
            return item.count;
        }
        else
            return React.createElement(Counter, { className: "counter" }, item.count);
    }, [item.count]);
    const isRenderIcon = Boolean(item.iconLeft);
    const isShowAccordion = hasChildren;
    const isRenderAccordion = isFlat ? false : isShowAccordion || !isRenderIcon;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledListItem, { disabled: item.disabled, onClick: handleItemClick, divider: false, selected: isSelected, button: true, "$isFlat": isFlat },
            isRenderAccordion && (React.createElement(StyledListItemIcon, null,
                React.createElement(Accordion, { "$hidden": !isShowAccordion, "$isOpen": isOpen, height: "20" }))),
            isRenderIcon && React.createElement(StyledListItemIcon, null, item.iconLeft),
            React.createElement(StyledListItemContent, { "$level2": level2, "$selected": isSelected },
                item.title,
                countElement)),
        !isLatest && item.divider && React.createElement(Divider, { className: "category-list__divider" }),
        !item.disabled && (React.createElement(ChildItems, { childItems: item.children, isOpen: isOpen, toggle: toggle, parent: item, onItemClick: onItemClick, checkSelection: checkSelection, isLatest: isLatest }))));
});
